import { Typography } from 'antd';
import { TitleProps } from 'antd/lib/typography/Title';

import cl from './styles.module.scss';

const { Title } = Typography;

interface IPageTitle extends TitleProps {
  subTitle?: boolean;
}

export const PageTitle = ({
  level = 3,
  title,
  style = {},
  className = '',
  subTitle = false,
}: IPageTitle) => {
  return (
    <Title
      level={level}
      className={`${cl.title} ${subTitle ? cl.subTitle : ''} ${className}`}
      style={style}>
      {title}
    </Title>
  );
};
